import { render } from "./Placeholder.vue?vue&type=template&id=ce9e6458&lang=html"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__